import { memo } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

function TooltipComponent({ children, TooltipText, direction = "right" }) {
  const renderTooltip = (props) => (
    <Tooltip style={{ width: "100%" }} id="button-tooltip" {...props}>
      {TooltipText}
    </Tooltip>
  );

  return (
    <OverlayTrigger placement={direction} overlay={renderTooltip}>
      {children}
    </OverlayTrigger>
  );
}

export default memo(TooltipComponent);
